/**
 * Created by agengmaulana on 4/25/17.
 */
import React from 'react'
import ReactDOM from 'react-dom'
import Comment_Article_Master from './src/component/comment_article/comment_article_master'
import Comment_Form from './src/component/comment_form/comment_form'
import Comment_Dropdown_Box from './src/component/comment_dropdown_box/comment_dropdown_box'
import Comment_Count from './src/component/comment_count/comment_count'
import Comment_Moderation from './src/component/comment_moderation/comment_moderation'
import Comment_Master_Row from './src/component/comment_row/comment_master_row'
import Comment_Pagination from  './src/component/comment_pagination/comment_pagination'
import {observer} from 'mobx-react';

import styles from './src/assets/css/comment.css'

@observer
class Index extends React.Component {

    constructor(props) {
        super(props);
        this.state = {firstLoadVerifiy:true};
    }
    render(){
        const {dataStore,isMobile,checkpilred} = this.props;
        const datastoresVerified = dataStore.datastoresVerified

        if(dataStore.datastoresModeration.length === 0)
        {
         var moderation = ''
        }
        else {
            moderation = dataStore.datastoresModeration.map(data=>

                <Comment_Moderation key={data.id} dataStore={data} datastoresVerified={datastoresVerified}/>
            )
        }

        const arrow = dataStore.inshowhide ? 'dk_icon-angle-down' : 'dk_icon-angle-up'
        const arrowshowhide = dataStore.inshowhide ?  <i className={styles.icon+' '+arrow}></i>  : <i className={styles.icon+' '+arrow}></i>
        const lihatbalasan = <a href="javascript:void(0);"  onClick={this.hiderow} className={styles.cmt_href}> <Comment_Count countComment={dataStore.countComment}/> {arrowshowhide}</a>
        return(
        <div className={styles.cmt_body} id="siap">
            <div className={styles.cmt_title_page+' '+styles.cmt_mb15}>KOMENTAR</div>

            { dataStore.datastores.length  > 0 ? <Comment_Article_Master dataStore={dataStore} datastoresVerified={datastoresVerified}/> : ''  }

            <Comment_Form sendTo="1" isMobile={isMobile} dataStore={dataStore}/>

            <div className={styles.cmt_countComment}>
                { dataStore.countComment== 0 ? '' : dataStore.configKomentar.showhide == 1 ? lihatbalasan : <Comment_Count countComment={dataStore.countComment}/> }

                { dataStore.countComment == 0 ? '' : <Comment_Dropdown_Box dataStore={dataStore} />}
            </div>

            <div id="showhide">

                {moderation}

                <Comment_Master_Row  dataStore={dataStore} isMobile={isMobile} />

                { dataStore.paging.item > 10 ? <center><Comment_Pagination dataStore={dataStore}/></center> : ' ' }

            </div>



        </div>
        )
    }

    componentDidMount(){
        var x = document.getElementById('showhide');
        this.props.dataStore.configKomentar.showhide == 1 ? x.style.display = 'none' : '';
        // let height = ReactDOM.findDOMNode(this).offsetHeight;
    }

    componentDidUpdate(prevProps) {
        if(this.props.dataStore.getDataVerifiedId.length > 0){ //delay props
            if(this.state.firstLoadVerifiy){
                var dataVerifiedId = this.props.dataStore.getDataVerifiedId.map(function(data){return data})
                var dataVerifiedIdPilred = this.props.dataStore.getDataVerifiedIdPilred.map(function(data){return data})
                var merge = dataVerifiedId.concat(dataVerifiedIdPilred)
                var distinct = this.props.dataStore.distincArray(merge)
                this.props.dataStore.fetchDataVerifiedUser(distinct)
                this.setState({firstLoadVerifiy:false}) //false
            }
        }
    }

    hiderow=()=>{

        var element = document.querySelector('.'+styles.urut);
        this.props.dataStore.inshowhide = !this.props.dataStore.inshowhide
        var x = document.getElementById('showhide');
        if (x.style.display === 'none') {
            x.style.display = 'block';
            element.style.display = 'block';
        } else {
            x.style.display = 'none';
            element.style.display = 'none';
        }

    }

}


var Go
Go = Index

module.exports = Go;



// WEBPACK FOOTER //
// ./static/index.js